import { T } from '../../styles/theme'

export default function SectionLabel({ children, style }) {
  return (
    <div style={{
      fontSize: 11, fontWeight: 600, color: T.muted, letterSpacing: 1.5,
      textTransform: 'uppercase', margin: '8px 20px', ...style
    }}>
      {children}
    </div>
  )
}
